import {
  aLogMappingOptions,
  mockParsingPatternOptionsQueryOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockParsingPatternOptionsQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          logMappingOptions: aLogMappingOptions(
            {},
            new Set<string>([
              'fieldValueTypeOptions',
              'logFormatOptions',
              'recordTypeOptions',
            ])
          ),
        },
      });
    }
  ),
];
